// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { ButtonIcon } from "@insite/mobius/Button";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import { floatingTooltipStyles } from "@synd/App/Components/FloatingTooltip/FloatingTooltip";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, getSystemColor, styledScrollbar } from "@synd/XDL/Utilities";
import { css } from "styled-components";

floatingTooltipStyles.tooltipContent = {
    css: css`
        background-color: ${color("common.ui7")};
        z-index: ${getProp("theme.zIndex.tooltip")};
        color: ${color("common.ui1")};
        border-radius: 2px;
        max-width: 430px;
        ${({ hasTitleSection }: any) =>
            !hasTitleSection &&
            css`
                padding: 12px;
            `}
    `,
};

floatingTooltipStyles.tooltipArrow = {
    width: 16,
    height: 8,
    strokeWidth: 1,
    style: {
        fill: getSystemColor("common.ui7"),
    },
};

floatingTooltipStyles.drawerContent = {
    css: css`
        background-color: ${color("common.ui1")};
        display: flex;
        position: fixed;
        flex-direction: column;
        right: 0;
        top: 0;
        height: 100vh;
        width: 333px;
        z-index: ${getProp("theme.zIndex.drawerOverlay")};
        transition: right 0.3s ease-in-out;
        visibility: hidden;
        transform: translateX(349px); // 333px width + 16px margin
        transition:
            transform 0.5s ease-in-out,
            visibility 0s 0.5s;

        ${({ isMounted }: any) =>
            isMounted &&
            css`
                visibility: visible;
                transform: translateX(0);
                transition:
                    transform 0.5s ease-in-out,
                    visibility 0s;
            `}
    `,
};

floatingTooltipStyles.drawerClose = {
    variant: "link" as any,
    css: css`
        margin-left: auto;
        &&&&&:not(:disabled) {
                &,
                & ${ButtonIcon} {
                    color: ${color("common.ui6")};
                }
            }
            &&&&:not(:disabled):hover ${ButtonIcon} {
                color: ${color("common.ui10")};
            }
    `,
};

floatingTooltipStyles.titleWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        ${({ hasTitle }: any) =>
            hasTitle &&
            css`
                background: ${color("common.ui8")};
            `}
        & > div {
            display: flex;
            gap: 8px;
            flex-wrap: nowrap;
            & > ${TypographyStyle} {
                font-size: ${getProp("theme.typography.h4.size")};
                line-height: ${getProp("theme.typography.h4.lineHeight")};
                font-weight: ${fontConfig.weight.bold};
            }
        }
        padding: 12px 16px;
    `,
};

floatingTooltipStyles.drawerInnerContent = {
    css: css`
        ${({ isContainer }: any) =>
            isContainer &&
            css`
                padding: 16px;
                ${styledScrollbar({ width: 4 })}
            `}
    `,
};
